module.exports = __webpack_public_path__ + "assets/50476bb29ac50d0f944db14c54288905.png";